import React, { Component } from 'react'
import { Button, FormGroup, FormControl } from "react-bootstrap"
import logologin from '../../Comman/images/logo-new.png'

import logobackground from '../../Comman/images/loginbg.png'
import { Redirect, withRouter } from 'react-router-dom'
import SimpleReactValidator from 'simple-react-validator';

const inputStyle = {
  margin: '15px',
 // border: '5px solid pink'
};

class organizationComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      organizationName: '',
      organizationNumber: '',
      organizationPhoneNumber: '',
      organizationAddress: '',
      pinCode: '',
      city: '',
      state: '',
      country: '',
      firstName:'',
      lastName:'',
      phoneNumber:'',
      emailId:'',
      userName:'',
      password:'',
      adminRadio: true,
      userRadio: false,
      redirectAdmin: false,
      redirectUser: false,
      orgNameValid:''
    };
    this.userChange = this.userChange.bind(this)
    this.adminChange = this.adminChange.bind(this)
  }
  

  submitOrganization = event => {
    
    if (this.validator.allValid()) {
     
      this.props.checkOrganization(
        this.state.organizationName
      );
    }
    else {
      this.validator.showMessages();
      this.forceUpdate();
    }
    event.preventDefault();
  }

  componentWillMount() {
    this.validator = new SimpleReactValidator(
      {
        validators: {
          allowSwedish: {  // name the rule
            message: 'The :attribute may only contains letters.',
            rule: (val, params, validator) => {
              return validator.helpers.testRegex(val,/^[a-zA-ZäöåÄÖÅ_ ]+$/) && params.indexOf(val) === -1
            },
            messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
            required: true  // optional
          }
        }
      }
    );
    let prevState=this.props.history.location;
    
    if(prevState.state!==undefined){
      this.setState({
        organizationName: prevState.state.previousInfo.organizationName,
        organizationNumber: prevState.state.previousInfo.organizationNumber,
        organizationPhoneNumber: prevState.state.previousInfo.organizationPhoneNumber,
        organizationAddress: prevState.state.previousInfo.organizationAddress,
        pinCode: prevState.state.previousInfo.pinCode,
        city: prevState.state.previousInfo.city,
        state: prevState.state.previousInfo.state,
        country: prevState.state.previousInfo.country,
      })
    }
    
  }
  componentWillReceiveProps(nextProps) {
    
    if (nextProps.registerInfo.Message !== this.props.registerInfo.Message) {
   
      if(nextProps.registerInfo.Message=="Organization Name already exists."){
        this.setState({orgNameValid:nextProps.registerInfo.Message})
      }else{
        
        this.setState({ redirect: true })
      }
    }

  }
 


  validateForm() {

    if (this.state.organizationName.length > 0 && this.state.organizationNumber.length > 0 && this.state.organizationPhoneNumber.length > 0 && this.state.organizationAddress.length > 0 && this.state.pinCode.length > 0 && this.state.city.length > 0 && this.state.state.length > 0 && this.state.country.length > 0)
      return true;
    else
      return false;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value,
      orgNameValid:''
    });
  }

  setRedirect = () => {
    this.setState({
      redirect: true
    })
  }

  renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to={{
        pathname: '/adminRegistration',
        state: {
          organizationName: this.state.organizationName,
          organizationNumber: this.state.organizationNumber,
          organizationPhoneNumber: this.state.organizationPhoneNumber,
          organizationAddress: this.state.organizationAddress,
          pinCode: this.state.pinCode,
          city: this.state.city,
          state: this.state.state,
          country: this.state.country
        }
      }} />
    }
  }

  renderRedirectUser = () => {
    ;
    if (this.state.redirectUser) {
      return <Redirect to='/registration' />
    }
  }

  renderRedirectAdmin = () => {
  
    if (this.state.redirectAdmin) {
      //return <Redirect to='/Organization' />
    }
  }
  renderRedirectHeartRunner=()=>{
    if (this.state.redirectHeartRunner) {
      return <Redirect to='/heartrunner' />
    }
  }
  userChange(e) {
    ;
    if (e.currentTarget.value === "on") {
      this.setState({ adminRadio: true });
      this.setState({ userRadio: false });
    }
    else {
      this.setState({ userRadio: false });
      this.setState({ adminRadio: true });
    }
    this.setState({ redirectUser: true });
  }

  adminChange(e) {
    
    if (e.currentTarget.value === "on") {
      this.setState({ userRadio: false });
      this.setState({ adminRadio: true });
    }
    else {
      this.setState({ adminRadio: true });
      this.setState({ userRadio: false });
    }
    this.setState({ redirectAdmin: true });
  }

  heartRunnerChange=(e)=> {
    
    if (e.currentTarget.value === "on") {
      this.setState({ userRadio: false });
      this.setState({ adminRadio: false });
      this.setState({ heartRunnerRadio: true });
    }
    else {
      this.setState({ heartRunnerRadio: true });
      this.setState({ userRadio: false });
      this.setState({ adminRadio: false });
    }
    this.setState({ redirectHeartRunner: true });
  }

  redirectLogin=()=>{
    this.props.history.push('/adminLogin');
  }

  render() {
    return (
     <div className="loginbg loginbg-ragistration">
        <div className="login-main">
          <div className="login-logo">
            <img src={logologin} />
          </div>
          
          <div className="k-form-field">
            {this.renderRedirectUser()}
            {this.renderRedirectAdmin()}
            {this.renderRedirectHeartRunner()}

            <input type="radio" name="radio" className="k-radio" id="userRegister" checked={this.state.userRadio} onChange={this.userChange} />
            <label className="k-radio-label">USER</label> &nbsp;&nbsp;&nbsp;&nbsp;
            <input type="radio" name="radio" className="k-radio" id="adminRegister" checked={this.state.adminRadio} onChange={this.adminChange} />
            <label className="k-radio-label">ORGANIZATION</label>
            <input type="radio" name="radio" className="k-radio" id="heartRunnerRegister" checked={this.state.heartRunnerRadio} onChange={this.heartRunnerChange} />
            <label className="k-radio-label">HEART RUNNER</label>
          </div>
          <div className="col-sm-12">
          <div className="stepLabel">
            <label>Step 1 - Organization Details</label>
          </div>
          <div className="clearfix"></div>
          </div>
          <form onSubmit={this.submitOrganization} className="regisForm" >
          <div className="row">

          
          <div className="col-sm-6">
            <FormGroup controlId="organizationName">
            <div className="login-fm">
              <FormControl
                className="login-main-form-control"
                type="text"
                autoFocus
                value={this.state.organizationName}
                onChange={this.handleChange}
                placeholder="Enter Organization Name"
              />
              </div>
              {this.state.orgNameValid!=""?
                <div className="srv-validation-message">{this.state.orgNameValid}</div>:''
              }
              {this.validator.message('organizationName', this.state.organizationName, 'required|alpha_num_dash_space|min:3')}
            </FormGroup>

          </div>
            <div className="col-sm-6">
            <FormGroup controlId="organizationNumber">
            <div className="login-fm">
              <FormControl
                className="login-main-form-control"
                value={this.state.organizationNumber}
                onChange={this.handleChange}
                type="text"
                autoFocus
                placeholder="Enter Organization Number"
              />
              </div>
              {this.validator.message('organizationNumber', this.state.organizationNumber, 'required|alpha_num_dash_space|min:3')}
            </FormGroup>
            </div>
            </div>
            <div className="row">
            <div className="col-sm-6">
            <FormGroup controlId="organizationPhoneNumber">
           <div className="login-fm">
              <FormControl
                className="login-main-form-control"
                value={this.state.organizationPhoneNumber}
                onChange={this.handleChange}
                type="text"
                autoFocus
                placeholder="Enter Organization Phone Number"
              />
              </div>
              {this.validator.message('organizationPhoneNumber', this.state.organizationPhoneNumber, 'required|phone|min:8|max:16')}
            </FormGroup>
            </div>
            <div className="col-sm-6">
            <FormGroup controlId="organizationAddress">
              <div className="login-fm">
              <FormControl
                className="login-main-form-control"
                value={this.state.organizationAddress}
                onChange={this.handleChange}
                type="text"
                autoFocus
                placeholder="Enter Organization Address"
              />
              </div>
              {this.validator.message('organizationAddress', this.state.organizationAddress, 'required|min:3')}
            </FormGroup>
            </div>
            </div>
            <div className="row">
            <div className="col-sm-6">
            <FormGroup controlId="pinCode">
                  <div className="login-fm">
              <FormControl
                className="login-main-form-control"
                value={this.state.pinCode}
                onChange={this.handleChange}
                type="text"
                autoFocus
                placeholder="Enter Pin Code"
              />
               </div>
               {this.validator.message('pinCode', this.state.state.pinCode, 'alpha_num_space|min:5')}
            </FormGroup>
           
            </div>
            <div className="col-sm-6">
            <FormGroup controlId="city">
                   <div className="login-fm">
              <FormControl
                className="login-main-form-control"
                value={this.state.city}
                onChange={this.handleChange}
                type="text"
                autoFocus
                placeholder="Enter City Name"
              />
              </div>
              {this.validator.message('city', this.state.city, 'required|allowSwedish|min:3')}
            </FormGroup>
            </div>
            </div>
            <div className="row">
            <div className="col-sm-6">
            <FormGroup controlId="state">
                <div className="login-fm">
              <FormControl
                className="login-main-form-control"
                value={this.state.state}
                onChange={this.handleChange}
                type="text"
                autoFocus
                placeholder="Enter State Name"
              />
              </div>
              {this.validator.message('state', this.state.state, 'required|allowSwedish|min:3')}
            </FormGroup>
            </div>
            <div className="col-sm-6">
            <FormGroup controlId="country">
                  <div className="login-fm">
              <FormControl
                className="login-main-form-control"
                value={this.state.country}
                onChange={this.handleChange}
                type="text"
                autoFocus
                placeholder="Enter Country Name"
              />
              </div>
              {this.validator.message('country', this.state.country,  'required|alpha_space|min:3')}
            </FormGroup>
            </div>
            </div>
            
            <div className="login-button">
              {this.renderRedirect()}
              <Button type="text" > NEXT </Button>
              <p>
              <a href="#"><span className="yellow"><button className="signUp" onClick={this.redirectLogin}>Login</button></span></a>
              </p>
              {/* onClick={this.setRedirect} */}
              <p>©copy <span className="yellow">ALECOM </span>2019</p>
            </div>
          </form>
        </div>
      </div>
    );
  }
}


export default withRouter(organizationComponent)
